<template>
<div class="msg-record-all">
    <div class="page-title">短信发送记录</div>
    <div class="page-title-bottom-line"></div>
    <div class="main-content-90">
        <div class="table-container">
            <el-table :data="tableData" style="width: 100%" :header-cell-style="changeTableHeaderStyle" :cell-style="changeTableStyle">
                <el-table-column align="center" label="操作" min-width="20%">
                    <template slot-scope="scope">
                        <el-button type="text" @click="findDetail(scope.row)">查看详情</el-button>
                    </template>
                </el-table-column>
                <el-table-column align="center" label="时间" min-width="25%">
                    <template slot-scope="scope">
                        <span>{{scope.row.create_time | formatDate}}</span>
                    </template>
                </el-table-column>
                <el-table-column align="center" prop="people_num" label="发送人数" min-width="20%">
                </el-table-column>
                <el-table-column align="center" prop="shortText" label="发送内容" min-width="35%">
                </el-table-column>
            </el-table>
        </div>
    </div>
    <el-dialog title="短信详情" :visible.sync="dialogTableVisible">
        <div class="msg-content">
            <div class="msg-content-title">短信内容：</div>
            <div class="msg-content-body">{{targetRecord.text}}</div>
        </div>
        <div class="linkman-title">发送对象：</div>
        <el-table :data="targetRecord.customer">
            <el-table-column property="customer_name" label="姓名" min-width="50%"></el-table-column>
            <el-table-column property="customer_phone" label="手机号" min-width="50%"></el-table-column>
        </el-table>
    </el-dialog>
</div>
</template>

<script>
import Tool from '../../assets/js/Tool.js';
import {
    mapGetters,
    mapMutations
} from 'vuex';
export default {
    data() {
        return {
            tableData: [],
            targetRecord: {},
            dialogTableVisible: false,

        }
    },
    computed: {
        ...mapGetters(['user', 'userTypeNum'])
    },
    created() {
        this.init();
    },
    methods: {
        changeTableHeaderStyle({
            row,
            rowIndex
        }) {
            return 'color:black; font-weight: bold;';
        },
        changeTableStyle({
            row,
            column,
            rowIndex,
            columnIndex
        }) {
            if (columnIndex == 5) {
                if (row.status_num == -1) {
                    return 'color: #FF3333;'
                } else if (row.status_num == 0) {
                    return 'color: #29bd7f;'
                } else if (row.status_num == 1) {
                    return 'color: #e6a23c;'
                }
            }
            return 'color: #000;'
        },
        init() {
            this.axios.get('marketing_message')
                .then(res => {
                    res.data.data.forEach(item => {
                        item.shortText = Tool.getShortText(item.text, 22) + '......';
                    });
                    this.tableData = res.data.data;
                })
        },
        // 查看详情
        findDetail(rowData) {
            this.targetRecord = rowData;
            this.dialogTableVisible = true;
        }
    }
}
</script>

<style scoped>
@import url(../../assets/css/base.css);

.msg-record-all {
    background-color: #F9F9F9;
}

.linkman-title,
.msg-content-title {
    font-size: 18px;
    font-weight: 700;
    padding-left: 10px;
    line-height: 40px;
}
</style>



// WEBPACK FOOTER //
// src/pages/marketingManage/MsgRecordAll.vue